import React from 'react';
import classnames from 'classnames';

import IntegrationImage, { integrationImageById } from 'assets/img/integrations';

import styles from './VerticalIntegrationIcons.module.scss';

interface VerticalIntegrationIconsProps extends StyleProps {
  /** @string - Integration name */
  itemIntegrationName: string;
}

export const VerticalIntegrationIcons: React.FC<VerticalIntegrationIconsProps> = ({
  className,
  itemIntegrationName,
}) => {
  const integrationIcon = integrationImageById(
    itemIntegrationName,
    IntegrationImage,
    true,
    styles.icon
  );

  return (
    <div className={classnames(styles.container, className)}>
      {itemIntegrationName && integrationIcon}
    </div>
  );
};
